export default __webpack_public_path__ + "static/media/Campaign - Settings.075de526.svg";